import { useEffect } from "react";

const SuccessToast = ({ closeToast = () => true, showToast = false }) => {
  useEffect(() => {
    if (showToast) {
      setTimeout(() => {
        closeToast();
      }, 5000);
    }
  }, [showToast, closeToast]);

  return (
    <div
      style={{
        borderRadius: "4px",
        padding: "10px 14px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        textAlign: "left",
      }}
      className={"tag-bg-success_opacity20 tag-mb-large"}
    >
      <div>
        <p className={"tag-label_bold"}>Thank you!</p>
        <p className={"tag-label_regular"}>Your submissions has been sent.</p>
      </div>
      <div onClick={closeToast} style={{ cursor: "pointer" }}>
        <i
          className={"icon-close tag-c-success"}
          style={{ fontSize: "20px" }}
        />
      </div>
    </div>
  );
};

export default SuccessToast;
